import { useState, useEffect } from 'react';
import { fetchWithAuth } from "./authHelpers";

export const usePlayer = () => {
    const [playerNames, setPlayerNames] = useState([]);
    const [players, setPlayers] = useState([]);
    const [loading, setLoading] = useState(true);
    const [playersLoading, setPlayersLoading] = useState(false);
    const [error, setError] = useState(null);
    const [playersError, setPlayersError] = useState(null);

    useEffect(() => {
        const fetchPlayerNames = async () => {
            try {
                const response = await fetchWithAuth(`${process.env.REACT_APP_BACKEND_URL}/players/names`, 'GET');
                const data = await response.json();
                if (Array.isArray(data)) {
                    setPlayerNames(data);
                } else {
                    console.error("Unexpected data format");
                }
            } catch (error) {
                setError(error);
                console.error("Error fetching player names");
            } finally {
                setLoading(false);
            }
        };

        fetchPlayerNames();
    }, []);

    const fetchAllPlayers = async () => {
        setPlayersLoading(true);
        setPlayersError(null);
        try {
            const response = await fetchWithAuth(`${process.env.REACT_APP_BACKEND_URL}/players/simple`, 'GET');
            if (!response.ok) {
                throw new Error('Failed to fetch players');
            }
            const data = await response.json();
            if (Array.isArray(data)) {
                setPlayers(data);
            } else {
                console.error("Unexpected data format");
                throw new Error("Invalid data format received");
            }
        } catch (error) {
            setPlayersError(error.message);
            console.error("Error fetching players");
        } finally {
            setPlayersLoading(false);
        }
    };

    return { 
        playerNames, 
        players,
        loading, 
        playersLoading,
        error,
        playersError,
        fetchAllPlayers
    };
};